export default __webpack_public_path__ + "static/media/wayfair2.8452fd0a.png";